import { render, staticRenderFns } from "./GatewaySettlementsAccount.vue?vue&type=template&id=97495732&"
import script from "./GatewaySettlementsAccount.vue?vue&type=script&lang=js&"
export * from "./GatewaySettlementsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports